// TODO: Agenda V2 no futuro
import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Button, Card, Modal } from 'react-bootstrap';
import { registerLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import history from '../../services/history';
import api from '../../services/api';
import { atualizarGuiaConvenio } from '../../services/prontuario';
import { medicoAgenda } from '../../helpers/agenda/medicos';
import { formatarData, toBrazilMidnightIso } from '../../util/utils';
import atividadeParaFatura, {
  isAtividadeConsulta,
  isAtividadeEcg,
} from '../../util/atividadeParaFatura';
import {
  GerarHorariosModal,
  SaveAgendaModal,
  SearchPatientsModal,
  FileUploadModal,
  EncaixeModal,
  AtualizarGuiaModal,
} from '../../components/agenda/Modals';
import ReceituarioMedico from '../receita/ReceituarioMedico';
import FormMedico from './FormMedico';
import AgendaForm from '../../components/agenda/Forms/AgendaForm';
import AgendaOverlayButtons from '../../components/agenda/AgendaOverlayButtons';
import AgendamentosTable from '../../components/agenda/Tables/AgendamentosTable';
import useAgenda from '../../hooks/useAgenda';
import useAgendaActions from '../../hooks/useAgendaActions';
import { AgendaActionsProvider } from '../../contexts/AgendaActionsContext';
import useFaturamento from '../../hooks/useFaturamento';
import useAtividades from '../../hooks/useAtividades';
import useLaudoHandlers from '../../hooks/useLaudoHandlers';
import useMedicos from '../../hooks/useMedicos';
import ActivitiesModal from '../../components/agenda/Modals/ActivitiesModal';
import FaturamentoModalCreate from '../../components/agenda/Modals/FaturamentoModalCreate';
import FaturamentoModalEdit from '../../components/agenda/Modals/FaturamentoModalEdit';

registerLocale('ptBR', ptBR);

export default function Agenda() {
  const location = useLocation();
  const medico = useSelector(state => state.doctor.profile);
  const { funcionario } = useSelector(state => state.funcionario);
  const agenda = useAgenda();
  const agendaActions = useAgendaActions({
    dateAgendaFormatted: agenda.dateAgendaFormatted,
    mutateAgendas: agenda.mutateAgendas,
  });
  const faturamento = useFaturamento();

  const {
    atividades,
    loadingAtividades,
    showAtividadesModal,
    closeAtividadesModal,
    handleAtividades,
    nomePac: nomePacAtividades,
    atividadesActions,
  } = useAtividades({
    idMedico: agenda.idMedico,
    medico: medico,
  });

  const {
    loadingAtividadeId,
    handleImprimir,
    handleImprimirTXT,
    handleEspelhoDoppler,
    handleEspelhoFisio,
    handleEspelhoFarmaco,
    handleImprimirEspelho,
    handleEspelhoTrans,
  } = useLaudoHandlers();
  const { medicos, selectMedicos } = useMedicos();

  // Local state
  const [selectedCodAgenda, setSelectedCodAgenda] = useState(undefined);
  const [selectedCodPaciente, setSelectedCodPaciente] = useState(undefined);
  const [agendamentoSelecionado, setAgendamentoSelecionado] = useState(null);
  const [camposParaAtualizar, setCamposParaAtualizar] = useState(null);
  const [formSnapshot, setFormSnapshot] = useState(null);
  const [showEncaixeModal, setShowEncaixeModal] = useState(false);
  const [showSearchPatientsModal, setShowSearchPatientsModal] = useState(false);
  const [showSearchMedicosModal, setShowSearchMedicosModal] = useState(false);
  const [showGeraHorarios, setShowGeraHorarios] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showGravaAgenda, setShowGravaAgenda] = useState(false);
  const [showReceitaModal, setShowReceitaModal] = useState(false);
  const [agendaForAtualizarGuia, setAgendaForAtualizarGuia] = useState(null);
  const [nomePacSearch, setNomePacSearch] = useState('');
  const loggedUser = medico || funcionario;
  const [isAgendamento, setIsAgendamento] = useState(false);
  const [criticalAlerts, setCriticalAlerts] = useState([]);
  const [pendingAgenda, setPendingAgenda] = useState(null);
  const [patientsModalForm, setPatientsModalForm] = useState({
    codPaciente: undefined,
    nomePac: undefined,
  });
  const [uploadAtividade, setUploadAtividade] = useState(undefined);
  const [receitaCodPaciente, setReceitaCodPaciente] = useState(undefined);

  const handleSelectionChange = useCallback(({ codAgenda, codPaciente }) => {
    setSelectedCodAgenda(codAgenda);
    setSelectedCodPaciente(codPaciente);
  }, []);

  const atualizarCamposFormulario = useCallback(campos => {
    setCamposParaAtualizar(prev => ({
      campos: { ...(prev?.campos || {}), ...campos },
      chave: Date.now(),
    }));
    if ('codPaciente' in campos) {
      setSelectedCodPaciente(campos.codPaciente);
    }
    if ('codAgenda' in campos) {
      setSelectedCodAgenda(campos.codAgenda);
    }
  }, []);

  const handleCamposFormularioAplicados = useCallback(() => {
    setCamposParaAtualizar(null);
  }, []);

  const setCodPaciente = useCallback(
    valor => {
      atualizarCamposFormulario({ codPaciente: valor });
      setPatientsModalForm(prev => ({ ...prev, codPaciente: valor }));
    },
    [atualizarCamposFormulario]
  );

  const setNomePac = useCallback(
    valor => {
      atualizarCamposFormulario({ nomePac: valor });
      setPatientsModalForm(prev => ({ ...prev, nomePac: valor }));
    },
    [atualizarCamposFormulario]
  );

  const handleRequestSearchPatients = useCallback(
    (formulario, { isAgendamento: abrirComoAgendamento = false } = {}) => {
      setPatientsModalForm({
        codPaciente: formulario.codPaciente,
        nomePac: formulario.nomePac,
      });
      setShowSearchPatientsModal(true);
      if (abrirComoAgendamento) setIsAgendamento(true);
    },
    []
  );

  const handleRequestSave = useCallback(formulario => {
    setFormSnapshot(formulario);
    setCriticalAlerts([]);
    setPendingAgenda(null);
    setShowGravaAgenda(true);
  }, []);

  const handleSetShowReceitaModal = useCallback(
    show => {
      if (show) setReceitaCodPaciente(selectedCodPaciente);
      setShowReceitaModal(!!show);
    },
    [selectedCodPaciente]
  );

  const handleAtualizarGuiaConvenio = useCallback(
    pAtividade => {
      closeAtividadesModal();
      faturamento.handleAtualizarGuiaConvenio(pAtividade);
    },
    [closeAtividadesModal, faturamento.handleAtualizarGuiaConvenio]
  );

  const atividadesActionsCompleto = useMemo(
    () => ({
      ...atividadesActions,
      setShowUpload: setShowUploadModal,
      setAtividade: setUploadAtividade,
      setShowReceitaModal: handleSetShowReceitaModal,
      loadingAtividadeId,
      handleImprimir,
      handleImprimirTXT,
      handleEspelhoDoppler,
      handleEspelhoFisio,
      handleEspelhoFarmaco,
      handleImprimirEspelho,
      handleAtualizarGuiaConvenio,
    }),
    [
      atividadesActions,
      setUploadAtividade,
      handleSetShowReceitaModal,
      loadingAtividadeId,
      handleImprimir,
      handleImprimirTXT,
      handleEspelhoDoppler,
      handleEspelhoFisio,
      handleEspelhoFarmaco,
      handleImprimirEspelho,
      handleAtualizarGuiaConvenio,
    ]
  );

  const preencherFormulario = useCallback((agendaPac, opcoes) => {
    setAgendamentoSelecionado({
      agendamento: agendaPac,
      opcoes,
      chave: Date.now(),
    });
  }, []);

  const handleAtualizarGuiaContextual = useCallback(agendaItem => {
    setAgendaForAtualizarGuia(agendaItem);
  }, []);

  const handleConfirmAtualizarGuia = useCallback(
    async ({ guiaConsulta, guiaEcg }) => {
      const agendaItem = agendaForAtualizarGuia;
      if (!agendaItem) return;

      try {
        const result = await api.get(
          `pacientes/${agendaItem.CODPAC}/atividades`
        );
        const atividadesLista = Array.isArray(result.data) ? result.data : [];

        const atividadesAgenda = atividadesLista.filter(
          atv =>
            atv.CODPAC === agendaItem.CODPAC &&
            atv.CODCONV === agendaItem.CODCONV &&
            atv.CODMEDICO === agendaItem.CODMED &&
            atv.DATALAUDO === agendaItem.DATAAGENDA
        );

        const updatePromises = [];
        const atualizadas = [];
        const ausentes = [];

        const payloadDaAtividade = (atividade, guia) => ({
          ...atividadeParaFatura(atividade),
          usuario: loggedUser?.apelido || loggedUser?.nome,
          dataFatura: toBrazilMidnightIso(atividade.DATALAUDO),
          ...guia,
        });

        if (guiaConsulta !== null) {
          const atvConsulta = atividadesAgenda.find(isAtividadeConsulta);
          if (atvConsulta) {
            updatePromises.push(
              atualizarGuiaConvenio(
                payloadDaAtividade(atvConsulta, { guia: guiaConsulta })
              )
            );
            atualizadas.push('consulta');
          } else {
            ausentes.push('consulta');
          }
        }

        if (guiaEcg !== null) {
          const atvEcg = atividadesAgenda.find(isAtividadeEcg);
          if (atvEcg) {
            updatePromises.push(
              atualizarGuiaConvenio(
                payloadDaAtividade(atvEcg, { guiaecg: guiaEcg })
              )
            );
            atualizadas.push('ECG');
          } else {
            ausentes.push('ECG');
          }
        }

        if (updatePromises.length > 0) {
          await Promise.all(updatePromises);
          const mensagem =
            atualizadas.length === 2
              ? 'Número GUIAS de ECG/Consulta atualizados com sucesso!'
              : `Guia de ${atualizadas[0]} atualizada com sucesso!`;
          toast.success(mensagem);
          ausentes.forEach(nome =>
            toast.warn(
              `Nenhuma atividade de ${nome} encontrada para atualizar.`
            )
          );
          agenda.mutateAgendas();
          setAgendaForAtualizarGuia(null);
        } else {
          toast.warn(
            'Nenhuma atividade correspondente encontrada na agenda para atualizar.'
          );
        }
      } catch (err) {
        toast.error(err?.response?.data?.error || 'Erro ao atualizar guias!');
      }
    },
    [loggedUser, agenda.mutateAgendas, agendaForAtualizarGuia]
  );

  const nomeMedicoAgenda = useMemo(
    () => medicos.find(m => m.CODMEDICO === agenda.idMedico)?.NOMEMED,
    [medicos, agenda.idMedico]
  );

  const agendaFaturandoRef = useRef(null);

  const handleSelectFaturamento = useCallback(
    pAgenda => {
      agendaFaturandoRef.current = pAgenda;
      faturamento.setShowModalFaturamento(true);

      const mapaProcedi = {
        1: 3,
        58: 3, // retorno abre a mesma escolha de ECG da consulta
        712: 12,
        713: 13,
        714: 13,
      };

      const codProcedi = mapaProcedi[pAgenda.CODPROCEDI] ?? pAgenda.CODPROCEDI;

      faturamento.setFatura({
        codPac: pAgenda.CODPAC,
        paciente: pAgenda.NOMEPAC,
        codConveniado: '',
        codSolicitou: '',
        codFaturou: pAgenda.CODMED,
        codRealizou: pAgenda.CODMED,
        conveniado: '',
        solicitou: '',
        faturou: pAgenda.NOMEMED,
        realizou: pAgenda.NOMEMED,
        codProcedi,
        procedimento: pAgenda.PROCEDIMENTO,
        codConv: pAgenda.CODCONV,
        convenio: pAgenda.CONVENIO,
        usuario: medico
          ? medico.apelido
          : funcionario
            ? funcionario.nome
            : undefined,
        dataFormatada: formatarData(pAgenda.DATAAGENDA),
        dataFatura: pAgenda.DATAAGENDA,
        guia: '',
        guiaecg: '',
        ecg: Number(codProcedi) === 3 ? '3' : '',
      });

      faturamento.handleValorFaturamento(
        { target: { value: codProcedi } },
        { codConv: pAgenda.CODCONV }
      );
    },
    [faturamento, medico, funcionario]
  );

  const handleInsertFaturamentoAgenda = useCallback(
    async event => {
      const resultado = await faturamento.handleInsertFaturamento(event);
      if (!resultado) return resultado;

      const pAgenda = agendaFaturandoRef.current;
      const observacao = pAgenda?.OBSERVACAO || '';
      if (!pAgenda?.CODAGENDA || observacao.startsWith('Fat-')) {
        return resultado;
      }

      try {
        const novaObservacao = `Fat-${observacao}`;
        await api.put('/agenda/observacao', {
          CODAGENDA: pAgenda.CODAGENDA,
          OBSERVACAO: novaObservacao,
        });
        agendaFaturandoRef.current = {
          ...pAgenda,
          OBSERVACAO: novaObservacao,
        };
        agenda.mutateAgendas();
      } catch (err) {
        toast.warn(
          err?.response?.data?.error ||
          'Faturamento gravado, mas a agenda não foi marcada.'
        );
      }

      return resultado;
    },
    [agenda.mutateAgendas, faturamento.handleInsertFaturamento]
  );

  const handleGravarAgenda = useCallback(async () => {
    const formulario = formSnapshot;
    if (!formulario?.codAgenda) return toast.warn('Selecione uma agenda!');

    try {
      const payload = {
        CODAGENDA: formulario.codAgenda,
        DATAAGENDA: formulario.dataAgenda,
        OBSERVACAO: formulario.observacoes,
        HORARIO: formulario.horaAgenda,
        CODMED: formulario.codMedico,
        codPac: formulario.codPaciente,
        codConv: formulario.codConvenio,
        codProcedi: formulario.codProcedimento,
        situacao:
          formulario.situacao === 'Aberta' ? 'Marcada' : formulario.situacao,
        atividade: formulario.atividade,
      };
      const { data } = await api.post('agendamento/validar', payload);
      const criticalAlertsFromApi = data?.criticalAlerts || [];
      if (criticalAlertsFromApi.length > 0) {
        setCriticalAlerts(criticalAlertsFromApi);
        setPendingAgenda(payload);
        return;
      }
      const res = await api.put('agendamento', payload);
      await agenda.mutateAgendas();
      toast.success(res.data.message);
      setCriticalAlerts([]);
      setPendingAgenda(null);
      setShowGravaAgenda(false);
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Erro ao gravar agenda!');
    }
  }, [formSnapshot, agenda.mutateAgendas]);

  const handleCloseCriticalModal = useCallback(async () => {
    if (!pendingAgenda) return;

    if (criticalAlerts.some(alert => alert.bloqueia)) {
      setShowGravaAgenda(false);
      setCriticalAlerts([]);
      setPendingAgenda(null);
      return;
    }

    try {
      const res = await api.put('agendamento', pendingAgenda);
      await agenda.mutateAgendas();
      toast.success(res.data.message);
      setCriticalAlerts([]);
      setPendingAgenda(null);
      setShowGravaAgenda(false);
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Erro ao gravar agenda!');
    }
  }, [pendingAgenda, criticalAlerts, agenda.mutateAgendas]);

  const handleAgendarPaciente = useCallback(
    (cod, nome) => {
      if (patientsModalForm.codPaciente === 1) {
        atualizarCamposFormulario({ codPaciente: cod, nomePac: nome });
        setPatientsModalForm(prev => ({
          ...prev,
          codPaciente: cod,
          nomePac: nome,
        }));
        setNomePacSearch(nome);
      }
      setShowSearchPatientsModal(false);
      setTimeout(() => {
        const elemConv = document.getElementById('codConvenio');
        if (!elemConv) return;
        elemConv.focus();
        elemConv.select();
      }, 200);
    },
    [patientsModalForm.codPaciente, atualizarCamposFormulario]
  );

  useEffect(() => {
    if (!agenda.idMedico || !agenda.dateAgendaFormatted) return;
    const currentSearchParams = new URLSearchParams(location.search);
    const currentMed = currentSearchParams.get('med');
    const currentDate = currentSearchParams.get('date');
    const medChanged = currentMed !== String(agenda.idMedico);
    const dateChanged = currentDate !== agenda.dateAgendaFormatted;

    if (medChanged || dateChanged) {
      agenda.markInternalUpdate();
      currentSearchParams.set('med', agenda.idMedico);
      currentSearchParams.set('date', agenda.dateAgendaFormatted);
      history.replace(`/agenda?${currentSearchParams.toString()}`);
    }
  }, [agenda.idMedico, agenda.dateAgendaFormatted]);

  const handleHideSaveAgendaModal = useCallback(() => {
    setShowGravaAgenda(false);
    setCriticalAlerts([]);
    setPendingAgenda(null);
  }, []);

  const handleRenderFormHeader = useCallback(
    ({ requestSave, requestSearchPatients }) => (
      <AgendaOverlayButtons
        setShowSearchMedicosModal={setShowSearchMedicosModal}
        setShowSearchPatientsModal={show => {
          if (show) requestSearchPatients({ isAgendamento: false });
          else setShowSearchPatientsModal(false);
        }}
        setShowGeraHorarios={setShowGeraHorarios}
        setShowEncaixeModal={setShowEncaixeModal}
        setShowGravaAgenda={show => {
          if (show) requestSave();
          else setShowGravaAgenda(false);
        }}
      />
    ),
    []
  );

  const patientsModalNomePac =
    patientsModalForm.codPaciente === 1
      ? patientsModalForm.nomePac
      : nomePacSearch;

  const patientsModalSetNomePac =
    patientsModalForm.codPaciente === 1 ? setNomePac : setNomePacSearch;

  return (
    <AgendaActionsProvider value={agendaActions}>
      <GerarHorariosModal
        show={showGeraHorarios}
        onHide={() => setShowGeraHorarios(false)}
        idMedico={agenda.idMedico}
        nomeMedico={nomeMedicoAgenda}
        dateAgendaFormatted={agenda.dateAgendaFormatted}
        mutateAgendas={agenda.mutateAgendas}
      />

      <SaveAgendaModal
        show={showGravaAgenda}
        onHide={handleHideSaveAgendaModal}
        codAgenda={formSnapshot?.codAgenda}
        nomePac={formSnapshot?.nomePac}
        onConfirm={
          criticalAlerts.length > 0
            ? handleCloseCriticalModal
            : handleGravarAgenda
        }
        criticalAlerts={criticalAlerts}
      />

      <AgendaForm
        onSelectionChange={handleSelectionChange}
        onRequestSave={handleRequestSave}
        onRequestSearchPatients={handleRequestSearchPatients}
        agendamentoSelecionado={agendamentoSelecionado}
        camposParaAtualizar={camposParaAtualizar}
        onCamposAplicados={handleCamposFormularioAplicados}
        header={handleRenderFormHeader}
      />

      <Card style={{ marginTop: 5 }}>
        <Card.Header
          className="d-flex flex-nowrap flex-md-wrap justify-content-start justify-content-md-center overflow-auto mb-1"
          style={{ gap: 5 }}
        >
          {medicoAgenda.map(m => (
            <Button
              key={m.codigo}
              size="sm"
              variant="outline-success"
              className={`flex-shrink-0 ${m.codigo === agenda.idMedico ? 'bg-success text-white' : ''
                }`}
              onClick={() => agenda.setIdMedico(m.codigo)}
            >
              {m.medico}
            </Button>
          ))}
        </Card.Header>
        <Card.Body>
          <AgendamentosTable
            agendamentos={agenda.agendamentos}
            dateAgenda={agenda.dateAgenda}
            setDateAgenda={agenda.setDateAgenda}
            codAgenda={selectedCodAgenda}
            preencherFormulario={preencherFormulario}
            handleAtividades={handleAtividades}
            setShowReceitaModal={handleSetShowReceitaModal}
            handleSelectFaturamento={handleSelectFaturamento}
            handleAtualizarGuiaContextual={handleAtualizarGuiaContextual}
            isLoading={agenda.isLoading}
          />
        </Card.Body>
      </Card>

      <ActivitiesModal
        show={showAtividadesModal}
        onHide={closeAtividadesModal}
        nomePac={nomePacAtividades}
        atividades={atividades}
        loadingAtividades={loadingAtividades}
        actions={atividadesActionsCompleto}
      />

      <SearchPatientsModal
        show={showSearchPatientsModal}
        onHide={() => setShowSearchPatientsModal(false)}
        codPacInicial={patientsModalForm.codPaciente}
        setCodPacInicial={setCodPaciente}
        nomePac={patientsModalNomePac}
        nomePacSearch={nomePacSearch}
        setNomePac={patientsModalSetNomePac}
        setNomePacSearch={setNomePacSearch}
        loggedUser={loggedUser}
        onAgendar={handleAgendarPaciente}
        isAgendamento={isAgendamento}
        setIsAgendamento={setIsAgendamento}
        onFaturarAgenda={handleSelectFaturamento}
      />

      <Modal
        show={showSearchMedicosModal}
        onHide={() => setShowSearchMedicosModal(false)}
        size="xl"
      >
        <Modal.Body>
          <FormMedico />
        </Modal.Body>
      </Modal>

      <FileUploadModal
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
        atividade={uploadAtividade}
      />

      <FaturamentoModalCreate
        show={faturamento.showModalFaturamento}
        onHide={() => {
          faturamento.setShowModalFaturamento(false);
          faturamento.setLoadingFaturamento(false);
        }}
        loading={faturamento.loadingFaturamento}
        fatura={faturamento.fatura}
        setFatura={faturamento.setFatura}
        selectMedicos={selectMedicos}
        medicos={medicos}
        handleChangeFaturamento={faturamento.handleChangeFaturamento}
        handleValorFaturamento={faturamento.handleValorFaturamento}
        setQuantidadeFetos={faturamento.setQuantidadeFetos}
        optarPorEcg={faturamento.optarPorEcg}
        handleInsertFaturamento={handleInsertFaturamentoAgenda}
        handleEspelhoTrans={handleEspelhoTrans}
        handleEspelhoFarmaco={handleEspelhoFarmaco}
        handleEspelhoFisio={handleEspelhoFisio}
        handleEspelhoDoppler={handleEspelhoDoppler}
        handleImprimirEspelho={handleImprimirEspelho}
      />

      <FaturamentoModalEdit
        show={faturamento.showModalUpdateFat}
        onHide={() => faturamento.setShowModalUpdateFat(false)}
        fatura={faturamento.fatura}
        setFatura={faturamento.setFatura}
        selectMedicos={selectMedicos}
        medicos={medicos}
        handleChangeFaturamento={faturamento.handleChangeFaturamento}
        handleValorFaturamento={faturamento.handleValorFaturamento}
        handleUpdateFaturamento={faturamento.handleUpdateFaturamento}
        handleExcluirFaturamento={faturamento.handleExcluirFaturamento}
      />

      <EncaixeModal
        show={showEncaixeModal}
        onHide={() => setShowEncaixeModal(false)}
      />

      <AtualizarGuiaModal
        show={agendaForAtualizarGuia != null}
        onHide={() => setAgendaForAtualizarGuia(null)}
        onConfirm={handleConfirmAtualizarGuia}
        agenda={agendaForAtualizarGuia}
      />

      <Modal
        show={showReceitaModal}
        onHide={() => setShowReceitaModal(false)}
        size="xl"
      >
        <Modal.Header className="font-weight-bold">
          RECEITUÁRIO MÉDICO
        </Modal.Header>
        <Modal.Body>
          <ReceituarioMedico
            closeModal={() => setShowReceitaModal(false)}
            codPaciente={receitaCodPaciente}
          />
        </Modal.Body>
      </Modal>
    </AgendaActionsProvider>
  );
}
